import { CrudService } from "nest-utilities-client";
export const employeeService = new (class EmployeeService extends CrudService {
    constructor() {
        super(process.env.API_URL + "/employees");
    }
})();
